import TalentEngineComponent from 'components/marketingSite/talentEngineV3/TalentEngineComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type TalentEngineLandingPageProps = WithBaseUrl;

const parseJSON = (resp: any): any => (resp.json ? resp.json() : resp);

const checkStatus = (resp: any): any => {
  if (resp.status >= 200 && resp.status < 300) {
    return resp;
  }

  return parseJSON(resp).then((resp: any) => {
    throw resp;
  });
};

const headers = { 'Content-Type': 'application/json' };

const TalentEngineLandingPage: React.FC<TalentEngineLandingPageProps> = ({
  baseUrl
}) => {
  const { t } = useI18n('talent-engine-landing-v3');

  const { locale } = useRouter();

  usePageTrack('Landing - Page Loaded');

  const [customers, setCustomers] = useState([]);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    fetch(
      `https://cms.getmanfred.com/api/talent-engine-page-customers?populate=%2A&pagination[pageSize]=100`,
      {
        headers,
        method: 'GET'
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setCustomers(data));
  }, []);

  useEffect(() => {
    fetch(
      `https://cms.getmanfred.com/api/talent-engine-page-faqs?populate=%2A&pagination[pageSize]=100&locale=${locale}`,
      {
        headers,
        method: 'GET'
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setFaqs(data));
  }, [locale]);

  return (
    <>
      <HeadMetadata
        title={t('talent-engine-landing.page_title')}
        url={APP_URLS.talentEngineLanding}
        desc={t('talent-engine-landing.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_talent_engine.png'
        )}`}
        indexable={true}
      />
      <TalentEngineComponent customers={customers} faqs={faqs} />
    </>
  );
};

export default TalentEngineLandingPage;

export const getStaticProps: GetStaticProps<
  TalentEngineLandingPageProps
> = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'talent-engine-landing-v3',
        'companies2'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
